import * as React from 'react'

import Stack from '@mui/material/Stack'

import type { ConditionModel } from '../../../typings'
import { ConditionItem } from './ConditionItem'

type Props = {
  conditions: ConditionModel[]
  editCondition: (value: ConditionModel, index: number) => void
  removeCondition: (idx: number) => void
}

export function ConditionsList(props: Props) {
  const { conditions, editCondition, removeCondition } = props

  return (
    <Stack gap={1.2}>
      {conditions.map((condition, idx) => (
        <ConditionItem
          data={condition}
          key={`condition_${idx}`}
          idx={idx}
          removeCondition={removeCondition}
          editCondition={editCondition}
        />
      ))}
    </Stack>
  )
}
